import React from 'react';
import NavBar from '../Components/TopNav';
import Footer from '../Components/Footer';
import { Outlet } from 'react-router-dom';

const Layout = () => {
    return (
      <div className="app-wrapper">
        <div className="position-fixed w-100 show-topnav-under z-3">
          <NavBar />
        </div>
        <main style={{ minHeight: "80vh" }} className='pt-5'>
          <Outlet />
        </main>
        <Footer />
      </div>
    );
};

export default Layout;
